import React, { Component, Fragment } from 'react'
import { Breadcrumb, Button, Card, Icon, Popconfirm, Row, Tabs, Tooltip } from 'antd'
import style from '../../style.css'
import BudgetForm from './BudgetForm'
import BudgetLineModal from './Lines/BudgetLineModal'
import BudgetLines from './Lines/BudgetLines'
import { strVal } from '../../../../modules/Utils'
import Status from '../../../../elements/Status'
import DocumentsCont from '../../../Common/Documents/DocumentsCont'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'

const { TabPane } = Tabs

class AddBudget extends Component {
  render() {
    const {
      type,
      submitting,
      fetching,
      ServicesSelectCmp,
      submit,
      fetch,
      update,
      formRef,
      actions,
      order,
      handleOps,
    } = this.props
    const Operations = ({ order, ...rest }) => {
      const ops = actions
        .filter((a) => a.key !== 'update')
        .map((a) => (
          <span>
            <Popconfirm
              placement="left"
              title={`Are you sure to ${a.value}?`}
              onConfirm={() => handleOps(a.key, order)}
              okText="Yes"
              cancelText="No">
              <a>{a.value}</a>
            </Popconfirm>
          </span>
        ))
      ops.push(<RefreshButton onClick={fetch} />)
      return (
        <div {...rest}>
          {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
        </div>
      )
    }
    return (
      <Fragment>
        <Card loading={fetching}>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Corporates</Breadcrumb.Item>
              <Breadcrumb.Item href={`#/corporates/budgets/`}>Budgets</Breadcrumb.Item>
              <Breadcrumb.Item>New Budget</Breadcrumb.Item>
            </Breadcrumb>
            {type === 'new' && <h2 className={style.title}>New Budgets Order</h2>}
            {type === 'edit' && (
              <h3 className={style.title}>
                <h2 className={'icon-text-header'}>
                  <Icon
                    type="barcode"
                    style={{
                      marginRight: '5px',
                      color: '#08c',
                    }}
                  />
                  <Tooltip title="Budget Order Code">{strVal(order, 'code')}</Tooltip>
                </h2>
                <Status value={strVal(order, 'status')} />
                <Operations style={{ marginTop: '10px' }} order={order} status={strVal(order, 'status')} />
              </h3>
            )}

            {type === 'new' && <p className={style.paragraph}>Create a new budget</p>}
          </Row>
        </Card>
        <Card className={style.contentCard}>
          <Tabs defaultActiveKey="details">
            <TabPane
              tab={
                <span>
                  <Icon type="info-circle" />
                  Details
                </span>
              }
              key="details">
              <BudgetLineModal ServicesSelectCmp={ServicesSelectCmp} {...this.props} />
              <BudgetForm ref={formRef} loading={fetching} {...this.props} />
              <h2>Budgets Lines</h2>
              <BudgetLines {...this.props} />
              <br />
              {type === 'new' && (
                <Button loading={submitting} type="primary" onClick={type !== 'edit' ? submit : update}>
                  {type === 'edit' ? 'Update' : 'Submit'}
                </Button>
              )}
            </TabPane>
            <TabPane
              disabled={type !== 'edit'}
              tab={
                <span>
                  <Icon type="folder-open" />
                  Documents
                </span>
              }
              key="docs">
              <DocumentsCont email={true} emailLabel={'Email with Invoice'} owner={order} />
            </TabPane>
          </Tabs>
        </Card>
      </Fragment>
    )
  }
}

AddBudget.propTypes = {}
AddBudget.defaultProps = {}

export default AddBudget
